import RecommendedBadge from './RecommendedBadge'

export * from './RecommendedBadge'

export default RecommendedBadge
